angular.module('picmonicng').directive('infiniteContainer', function () {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    template:
      "<div class=\"infinite-container\" ng-style=\"{'height':(picmonics.length * item_height)+'px', 'padding-top':(offset * item_height)+'px'}\" ng-transclude></div>",
  };
});
